import { getServiceURLserverSide } from "@domain/infrastructure";
import Toggles from '@domain/toggles/Toggles'

let isRefreshingToken = false;

async function waitUntilRefreshIsFinished(): Promise<void> {
    return new Promise(resolve => {
        const interval = setInterval(() => {
            if (!isRefreshingToken) {
                resolve();
                clearInterval(interval);
            }
        }, 300);
    });
}

interface FetchOptions extends RequestInit {
    hasRetriedRequest?: boolean;
}

export const fetchWithRefresh = async (url: string, options: FetchOptions = {}): Promise<Response> => {
    // Cambiar getServiceURL y sacarlo de common
    const refreshTokenUrl = `${getServiceURLserverSide('users')}/v1/auth/refresh`;

    // Middleware de solicitud
    if (![refreshTokenUrl].includes(url) && isRefreshingToken) {
        await waitUntilRefreshIsFinished();
    }

    const response = await fetch(url, options);

    // Middleware de respuesta
    if ([refreshTokenUrl].includes(url)) {
        isRefreshingToken = false;
    }

    if (response.status === 401) {
        if (options.hasRetriedRequest) {
            console.log('Request failed and has already been retried.');
            return response;
        }

        if (url === refreshTokenUrl) {
            console.log('Refresh token failed.');
            isRefreshingToken = false;
            return response
        }

        if (!isRefreshingToken) {
            console.log('Refreshing token...');
            isRefreshingToken = true;
            const refreshResponse = await fetch(refreshTokenUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Length': '0'
                }
            });
            isRefreshingToken = false;
            if (Toggles.isEnabled("preformLogin") && !refreshResponse.ok) {
                console.log('Refresh token failed with status:', refreshResponse.status);
                return response;
            }
            console.log('Token refreshed!');
            return fetchWithRefresh(url, { ...options, hasRetriedRequest: true });
        }

        await waitUntilRefreshIsFinished();
        return fetchWithRefresh(url, { ...options, hasRetriedRequest: true });
    }

    return response;

};

export default {
    fetchWithRefresh
}